import React from 'react';
import { useRangeSlider } from '../../hooks';
import { RangeSlider } from '../../components';
import styles from './styles.css';

export default function SettingsPanel({ firstSliderSettings, secondSliderSettings, children, resetAdvancedSettings }) {
	const firstSliderProps = useRangeSlider(firstSliderSettings);
	const secondSliderProps = useRangeSlider(secondSliderSettings);

	return (
		<div className={`${styles.wrapper}`}>
			<div className="uk-width-1-1">
				{firstSliderSettings ? (
					<div
						id="sliderContainer"
						className={`idp-settings-panel__date-picker advanced-settings ${
							secondSliderSettings ? 'idp-settings-panel__date-picker--two-sliders' : ''
						}`}
					>
						{secondSliderSettings && secondSliderProps ? (
							<div className="idp-settings-panel__date-picker-sliders">
								<div className="idp-settings-panel__date-picker-group">
									<label className="idp-settings-advanced__heading">{firstSliderSettings.title}</label>
									<div className="idp-settings-panel__range" id="range_1_wrapper">
										{firstSliderProps && <RangeSlider {...firstSliderProps} />}
									</div>
								</div>
								<div className="idp-settings-panel__date-picker-group">
									<label className="idp-settings-advanced__heading">{secondSliderSettings.title}</label>
									<div className="idp-settings-panel__range" id="range_2_wrapper">
										<RangeSlider {...secondSliderProps} />
									</div>
								</div>
							</div>
						) : (
							<>
								<label className="idp-settings-advanced__heading">{firstSliderSettings.title}</label>
								<div className="idp-settings-panel__range idp-settings-panel__range--full-width" id="range_1_wrapper">
									{firstSliderProps && <RangeSlider {...firstSliderProps} />}
								</div>
							</>
						)}
					</div>
				) : null}
				{children}
				<div className={`idp-settings-panel__highlight advanced-settings ${styles.resetButtonWrapper}`}>
					<button
						className={`uk-button  ${styles.resetButton}`}
						type="button"
						onClick={(e) => {
							e.preventDefault();
							resetAdvancedSettings.onClick();
						}}
					>
						{resetAdvancedSettings.text}
					</button>
				</div>
			</div>
		</div>
	);
}
